<script lang="ts">
  // component
  import BannerBase from "@retailer/svelte/Payments/Banners/Base.svelte";

  // props
  export let handleBannerClose: (type: string) => {};

  // data
  const comingSoonBannerType = "coming_soon_banner";

</script>

<div class="fizz-flex-item fizz-inset-square-16" data-testid={comingSoonBannerType}>
  <BannerBase
    iconType={"StatementCircle"}
    heading="Coming soon: Pay Spec’s invoices with ProviPay"
    onClose={() => handleBannerClose(comingSoonBannerType)}
  >
    <p class="fizz-text-medium">
      ProviPay will be available soon to Spec’s customers. ProviPay makes invoice payment a breeze,
      with features like scheduling payments, applying credits and setting up auto pay.
    </p>
  </BannerBase>
</div>
